/**
 * Base sandbox for iframes rendering agent-generated HTML; surfaces compose
 * extras onto it. Never add `allow-same-origin` — with `allow-scripts` it
 * hands the document back an origin holding session state.
 */
export const AGENT_HTML_IFRAME_SANDBOX =
  'allow-scripts allow-forms allow-popups';
